module.exports = __webpack_public_path__ + "static/media/16.6bf9789c.jpg";